import { styled } from "@mui/material/styles";

/**
 * The column of controls at the end of a table's toolbar: the search and the table's own buttons in
 * one row, and the page's action under them. Below md the column lies down into a row.
 *
 * Moved here from the permissions table styles (#6175), where nineteen tables outside permissions
 * were importing it from; the permissions page that defined it is going away.
 */
export const ToolbarButtonsContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  display: "flex",
  alignItems: "end",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

export const ToolbarButtons = styled("div")(() => ({
  display: "flex",
  alignItems: "end",
  flexWrap: "nowrap",
}));
